import { cn } from '@/lib/utils/cn'

/**
 * The dimmed layer behind an overlay, and the click-away target for dropdowns.
 *
 * A native <button>, not a div with onClick: a clickable div is invisible to
 * keyboard and assistive tech. `tabIndex={-1}` keeps it out of the tab order —
 * Escape and the overlay's own close control are the keyboard paths — while
 * still being a real interactive element.
 */
export function Backdrop({
  onClick,
  label = 'Close',
  dim = true,
  className,
}: {
  onClick: () => void
  label?: string
  dim?: boolean
  className?: string
}) {
  return (
    <button
      type="button"
      tabIndex={-1}
      aria-label={label}
      onClick={onClick}
      className={cn(
        'fixed inset-0 z-40 cursor-default',
        dim && 'bg-surface-inverse/40',
        className,
      )}
    />
  )
}
